import { render, staticRenderFns } from "./sub-inquiry.vue?vue&type=template&id=40caf508&scoped=true&"
import script from "./sub-inquiry.vue?vue&type=script&lang=js&"
export * from "./sub-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./sub-inquiry.vue?vue&type=style&index=0&id=40caf508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40caf508",
  null
  
)

export default component.exports